<template>
  <modal
    id="onboarding-modal"
    :size="'lg'"
    :confirm-text="'Save'"
    confirm-class="btn-primary"
    @confirm="saveChoice"
    :close-text="'Cancel'"
    close-class="btn-default pull-left"
    :isLoading="isLoading"
    :showExit="false"
  >
    <template v-slot:title> Edit User Onboarding </template>

    <template v-slot:body>
      <p>
        Customize the pre-Inbox experience is for your users. <br />
        Download a
        <a href="/capsiminbox/resources/CapsimInbox_Standard_Onboarding_PDF_V1.pdf" target="_blank"
          >Standard Onboarding guide</a
        >
        to review the pre-inbox materials and tools that we have created for your users.
      </p>

      <accordion-list id="onboarding-accordion">
        <accordion-panel-radio
          :currentSelectedKey="localTemplateKey.toString()"
          :id="'1'"
          @updateRadioKey="updateRadioKeyHandler($event)"
        >
          <template v-slot:title>
            <input
              type="radio"
              id="default"
              name="onboarding"
              value="1"
              v-model="localTemplateKey"
            />
            <label for="default">CapsimInbox Standard Onboarding</label>
            <p class="ml-20">The complete pre-inbox experience.</p>
          </template>
          <template v-slot:body>
            <img src="/capsiminbox/images/CapsimInbox-AP_Onboarding-Standard.png" />
            <p class="onboarding-desc ml-15">
              The Standard Onboarding includes Capsim-created content that helps familiarize users
              with the tool.
            </p>
          </template>
        </accordion-panel-radio>
        <accordion-panel-radio
          :id="'2'"
          :currentSelectedKey="localTemplateKey.toString()"
          @updateRadioKey="updateRadioKeyHandler($event)"
        >
          <template v-slot:title>
            <input type="radio" id="lite" name="onboarding" value="2" v-model="localTemplateKey" />
            <label for="lite">CapsimInbox "Lite" Onboarding</label>
            <p class="ml-20">
              The Lite onboarding version strips out all of Capsim's pre-designed training
              materials.
            </p>
          </template>
          <template v-slot:body>
            <img width="auto" src="/capsiminbox/images/CapsimInbox-AP_Onboarding-Lite.png" />
            <p class="onboarding-desc ml-15">
              All pages included in the Lite Onboarding can be customized by the author.
            </p>
          </template>
        </accordion-panel-radio>
        <accordion-panel-radio
          :id="'3'"
          :currentSelectedKey="localTemplateKey.toString()"
          @updateRadioKey="updateRadioKeyHandler($event)"
        >
          <template v-slot:title>
            <input
              type="radio"
              id="customOnboarding"
              name="onboarding"
              value="3"
              v-model="localTemplateKey"
            />
            <label for="customOnboarding"> CapsimInbox Custom Onboarding </label>
            <p class="ml-20">Choose which modules you want to include pre-inbox.</p>
          </template>
          <template v-slot:body>
            <div class="row">
              <div class="col-md-2 col-half-offset">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <p class="icon-desc">Self Assessment</p>
                  </div>
                  <img width="auto" src="/capsiminbox/images/Onboarding_Self-Assessment.svg" />
                </div>
              </div>
              <div class="col-md-2 col-half-offset">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <p class="icon-desc">What is CapsimInbox</p>
                  </div>
                  <img width="auto" src="/capsiminbox/images/Onboarding_What-is-Inbox.svg" />
                </div>
              </div>
              <div class="col-md-2 col-half-offset">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <p class="icon-desc">Scenario</p>
                  </div>
                  <img width="auto" src="/capsiminbox/images/Onboarding_Scenario.svg" />
                </div>
              </div>
              <div class="col-md-2 col-half-offset">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <p class="icon-desc">Practice</p>
                  </div>
                  <img width="auto" src="/capsiminbox/images/Onboarding_Practice.svg" />
                </div>
              </div>
              <div class="col-md-2 col-half-offset">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <p class="icon-desc">Opening-Scene</p>
                  </div>
                  <img width="auto" src="/capsiminbox/images/Onboarding_Opening-Scene.svg" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <template v-for="(option, index) in onboardingCustomPageOptions">
                    <div class="col-md-2 col-half-offset">
                      <div class="col-md-12 text-center mt-10">
                        <v-switch
                          style="zoom: 0.9"
                          :selected="onboardingCustomPageOptions[index]"
                          :emit-on-mount="false"
                          @input="
                            (val) => {
                              onboardingCustomPageOptions[index] = val;
                            }
                          "
                        ></v-switch>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-md-12">
                <p class="toggle-desc">
                  Toggle on any pages that you would like participants to view. Deactivated pages
                  will impact associated authoring features. If all pages are deactivated, then the
                  user will enter the Inbox immediately from their dashboard.
                </p>
              </div>
            </div>
          </template>
        </accordion-panel-radio>
      </accordion-list>
    </template>
  </modal>
</template>

<script>
  import { mapActions } from 'vuex';
  import Switch from '@shared/switch.vue';

  export default {
    components: {
      'v-switch': Switch,
    },
    props: {
      onboardTemplateKey: {
        type: Number,
        require: true,
      },
      customPageKeysArray: {
        type: Array,
        require: true,
      },
    },

    data() {
      return {
        localTemplateKey: this.onboardTemplateKey,
        onboardingCustomPageOptions: new Array(5).fill(false),
        trackPageOptionKeysFromDB: [],
        isLoading: false,
      };
    },
    mounted() {
      this.getCustomPageKeySelections();
      $(`#collapse${this.localTemplateKey}`).collapse('show');
    },

    methods: {
      ...mapActions(['SET_MILESTONE']),
      ...mapActions('editMode/version', ['updateVersion']),
      updateRadioKeyHandler(val) {
        this.localTemplateKey = parseInt(val);
      },

      selectOnboardingType(type) {
        $(`#collapse${this.localTemplateKey}`).collapse('hide');
        this.localTemplateKey = type;
        $(`#collapse${type}`).collapse('show');
      },
      getCustomPageKeySelections() {
        for (let item of this.customPageKeysArray) {
          const idx = item.FK_onboardPageKey - 1;
          this.onboardingCustomPageOptions.splice(idx, 1, true);
        }
        this.trackPageOptionKeysFromDB = [...this.onboardingCustomPageOptions];
      },

      async setUpdatedPageKeyOptions() {
        const updatedPageKeysArr = [];
        for (let i in this.onboardingCustomPageOptions) {
          if (this.onboardingCustomPageOptions[i] !== this.trackPageOptionKeysFromDB[i]) {
            updatedPageKeysArr.push({
              toggle: this.onboardingCustomPageOptions[i],
              FK_onboardPageKey: parseInt(i) + 1,
              sequence: parseInt(i) + 1,
            });
          }
        }

        return updatedPageKeysArr;
      },

      async saveChoice() {
        this.SET_MILESTONE({
          message: 'Adjust a Gadget',
          tooltipDesc: this.tooltips.milestones['9'],
          timeout: 8000,
          milestoneKey: 9,
        });
        const updatedPageKeysResult = await this.setUpdatedPageKeyOptions();
        this.isLoading = true;
        await this.updateVersion({
          versionKey: this.$route.params.resourceKey,
          payload: {
            onboardTemplateKey: this.localTemplateKey,
            customPageKeysArray: updatedPageKeysResult,
          },
        });
        this.isLoading = false;
        // reset page keys to new update
        this.trackPageOptionKeysFromDB = [...this.onboardingCustomPageOptions];
        $(`#collapse${this.localTemplateKey}`).collapse('show');
        $('#onboarding-modal').modal('hide');
      },
    },
  };
</script>

<style lang="scss" scoped>
  img {
    max-height: 120px;
    max-width: 100%;
  }

  .col-half-offset {
    margin-left: 2.666666667%;
  }

  .onboarding-desc,
  .toggle-desc {
    font-size: 14px;
  }

  .panel-group .panel + .panel {
    margin-top: 0px;
  }

  .icon-desc {
    font-size: 12px;
    margin-bottom: 2px;
    font-weight: 700;
  }

  label {
    margin-left: 2px;
  }
</style>
